import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    loading: { type: Boolean, default: false }
  }

  connect() {
    // Setup event listeners
    this.element.addEventListener("click", (e) => {
      if (e.target === this.element) {
        this.close()
      }
    })
    
    // Add keyboard listener
    document.addEventListener("keydown", this.handleKeyDown.bind(this))
    
    // Watch for changes to the modal content
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          if (this.element.innerHTML.trim() !== '') {
            this.show()
          } else {
            this.hide()
          }
        }
      })
    })
    
    observer.observe(this.element, { childList: true })
  }
  
  disconnect() {
    document.removeEventListener("keydown", this.handleKeyDown.bind(this))
  }
  
  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
  
  close() {
    this.element.innerHTML = ""
    this.hide()
  }
  
  show() {
    this.element.classList.remove("hidden")
    this.element.classList.add("fixed", "inset-0", "flex", "items-center", "justify-center", "z-50", "bg-black", "bg-opacity-50")
    document.body.classList.add("overflow-hidden")
  }
  
  hide() {
    this.element.classList.add("hidden")
    this.element.classList.remove("fixed", "inset-0", "flex", "items-center", "justify-center", "z-50", "bg-black", "bg-opacity-50")
    document.body.classList.remove("overflow-hidden")
  }
  
  open(event) {
    event.preventDefault()
    
    const url = event.currentTarget.getAttribute('href')
    this.loadingValue = true
    this.show()
    
    // Create loading indicator
    this.element.innerHTML = `
      <div class="bg-white p-8 rounded-lg shadow-lg relative max-w-md w-full max-h-screen overflow-y-auto">
        <div class="flex justify-center items-center h-32">
          <svg class="animate-spin h-10 w-10 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
      </div>
    `
    
    // Fetch content
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => response.text())
      .then(html => {
        // Create modal container
        this.element.innerHTML = `
          <div class="bg-white p-6 rounded-lg shadow-lg relative max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            <button data-action="click->modal#close" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
              <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
            <div class="modal-content">${html}</div>
          </div>
        `
        this.loadingValue = false
      })
      .catch(error => {
        console.error('Error loading modal content:', error)
        this.close()
      })
  }
}